import { FormEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  PatientDiscountFormFields,
  usePatientDiscountFormGroupEffect,
} from '../../../forms/effects/partner';
import {
  useFindDiscountByCodeEffect,
  useCreateCartDiscountEffect,
  discountSlice,
} from '../../../services';

export const usePatientDiscountFormEffect = () => {
  const dispatch = useDispatch();

  const { isValid, members, getFieldValues } =
    usePatientDiscountFormGroupEffect();

  const [discountData, setDiscountData] = useState({});
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const findDiscountByCodeEffect = useFindDiscountByCodeEffect();
  const createCartDiscountEffect = useCreateCartDiscountEffect();

  useEffect(() => {
    const discount = findDiscountByCodeEffect.discount;
    const cartLoading = createCartDiscountEffect.loading;
    const cartSuccess = createCartDiscountEffect.success;
    const cartError = createCartDiscountEffect.error;
    const discountError = findDiscountByCodeEffect.discount.error;

    if (discountError && !cartSuccess) {
      setError(true);
      setErrorMessage(discountError);
    }

    if (discount.data && !cartLoading && !cartSuccess && !cartError) {
      createCartDiscountEffect.createCartDiscount(
        discount.data.id,
        discount.data.code
      );
      dispatch(discountSlice.actions.clear());
      setDiscountData(discount);
    }
  }, [
    dispatch,
    discountSlice,
    findDiscountByCodeEffect,
    createCartDiscountEffect,
  ]);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = getFieldValues() as PatientDiscountFormFields;
    const code = form.code as string;

    findDiscountByCodeEffect.findDiscountByCode(code);
  };

  const success = createCartDiscountEffect.success;
  const loading =
    findDiscountByCodeEffect.loading || createCartDiscountEffect.loading;

  return {
    isValid,
    members,
    onSubmit,
    loading,
    success,
    error,
    discountData,
    errorMessage,
  };
};
